import React from "react";
import {DataTableColumnProps} from "peggirkit";
import {FormattedMessage, IntlShape} from "react-intl";
import ViewFormatter from "@widgets/employees/overview/table/columns/ViewFormatter";
import {editJobApplication} from "@/routing/Router";
import {JobApplicationStatus} from "@/data/entities/jobApplication";
import {JobApplicationInDataTable} from "@widgets/jobApplications/overview/JobApplications";
import DateFormatter from "@widgets/employees/overview/table/columns/DateFormatter";
import JobApplicationStatusFormatter
    from "@widgets/jobApplications/overview/table/columns/JobApplicationStatusFormatter";
import {JobOpeningPreview} from "@/data/entities/jobOpening";

export const getJobApplicationsDataTableColumns = (
    intl: IntlShape,
): DataTableColumnProps<JobApplicationInDataTable>[] => ([
    {
        id: "id",
        label: {displayName: intl.formatMessage({id: "id"})},
        primary: false,
        visibility: "always-hidden",
    },
    {
        id: "jobOpening",
        label: {displayName: intl.formatMessage({id: "jobTitle"})},
        primary: true,
        sortingConfig: {enabled: false},
        formatter: (jobOpening: JobOpeningPreview) => <FormattedMessage id={`jobTitle.${jobOpening.type}`}/>,
    },
    {
        id: "lastName",
        label: {displayName: intl.formatMessage({id: "name"})},
        primary: false,
        sortingConfig: {
            enabled: true,
        },
        formatter: (lastName: string, {firstName}) => `${lastName}, ${firstName}`,
    },
    {
        id: "creationDate",
        label: {displayName: intl.formatMessage({id: "receivedOn"})},
        primary: false,
        sortingConfig: {
            enabled: true,
            sorted: "desc",
        },
        align: "right",
        formatter: (creationDate: string) => <DateFormatter date={creationDate}/>,
    },
    {
        id: "status",
        label: {displayName: intl.formatMessage({id: "status"})},
        primary: false,
        sortingConfig: {
            enabled: false,
        },
        align: "right",
        formatter: (status: JobApplicationStatus) => <JobApplicationStatusFormatter status={status}/>,
    },
    {
        id: "options",
        label: {
            displayName: intl.formatMessage({id: "view"}),
            hide: true,
        },
        primary: false,
        sortingConfig: {
            enabled: false,
        },
        align: "right",
        formatter: (_, {id}) =>
            <ViewFormatter to={editJobApplication(id).absolutePath()}/>,
    },
]);